import { referenceForwardArgs, sizeConst } from '@klarna/designtokens';
export default {
  'space.0': sizeConst(0),
  'space.none': referenceForwardArgs('space.0'),
  'space.50': sizeConst(4),
  'space.100': sizeConst(8),
  'space.unit': referenceForwardArgs('space.100'),
  'space.150': sizeConst(12),
  'space.200': sizeConst(16),
  'space.300': sizeConst(24),
  'space.400': sizeConst(32),
  'space.500': sizeConst(40),
  'space.600': sizeConst(48),
  'space.800': sizeConst(64),
  'space.1000': sizeConst(80),
  'space.1200': sizeConst(96),
  'space.2000': sizeConst(160)
};
//# sourceMappingURL=index.js.map